module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-133.0d74af5c.jpg";